import React from 'react';

export default function PageSpinner({ label }: { label?: string }) {
  return (
    <div className="min-h-[60vh] w-full flex flex-col items-center justify-center gap-3">
      <div className="h-10 w-10 rounded-full border-4 border-primary/20 border-t-primary animate-spin" />
      {label ? <div className="text-sm text-muted-foreground">{label}</div> : null}
    </div>
  );
}
